import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { findContentPost } from '../lib/contentBlog';
import { api } from '../lib/api';
import BlogCTA from '../components/BlogCTA';
import MarkdownArticle from '../components/MarkdownArticle';

function normalizePost(p) {
  return {
    ...p,
    metaTitle: p.metaTitle || p.seo_title || p.meta_title,
    metaDescription: p.metaDescription || p.meta_description,
    cover_image: p.cover_image || p.featured_image_url,
    body: p.body || p.body_markdown || '',
    city: p.city || p.city_tags?.[0] || '',
    bookingUrl: p.bookingUrl || (p.city_tags?.[0] ? `/cities/${String(p.city_tags[0]).toLowerCase().replace(/[^a-z0-9]+/g, '-')}` : ''),
    canonicalUrl: p.canonicalUrl || `https://www.ghostie.it/blog/${p.slug}`,
  };
}

export default function BlogPost() {
  const { slug } = useParams();
  const [dbPost, setDbPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const staticPost = findContentPost(slug);
  const p = dbPost || staticPost;

  useEffect(() => {
    setDbPost(null); setNotFound(false);
    api.get(`/blog/${slug}`).then(r => setDbPost(normalizePost(r.data))).catch(() => setNotFound(true));
  }, [slug]);

  useEffect(() => {
    if (!p) return;
    document.title = p.metaTitle || p.title || 'Ghostie Blog';
    let description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.setAttribute('name', 'description');
      document.head.appendChild(description);
    }
    description.setAttribute('content', p.metaDescription || p.excerpt || '');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', p.canonicalUrl || `https://www.ghostie.it/blog/${p.slug}`);
  }, [p]);

  if (!p && !notFound) return <div className="min-h-[40vh] flex items-center justify-center text-[#a3a3a3]">Loading...</div>;
  if (!p) return <div className="min-h-[40vh] flex items-center justify-center text-[#a3a3a3]">Post not found.</div>;
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <Link to="/blog" className="link-soft text-sm" data-testid="blog-back">← Back to journal</Link>
      <h1 className="text-4xl sm:text-5xl font-heading font-semibold mt-4 mb-6 leading-tight">{p.title}</h1>
      {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full rounded-3xl mb-8"/>}
      <MarkdownArticle markdown={p.body} />
      <BlogCTA city={p.city} slug={p.slug} bookingUrl={p.bookingUrl} />
    </article>
  );
}
